// @flow
import React, { useContext, useState } from 'react';
import Helmet from 'react-helmet';
import { ImportantInformation } from '@latitude/important-information-rebrand';
import MobileAppInstallPrompts from '@latitude/mobile-app-install-prompt/MobileAppInstallPrompt';
import Layout from '@/components/layout';
import { PADDING, REBRAND_COLOR } from '@latitude/core/utils/constants';
import PromoBanner from '@/components/PromoBannerRebrand/PromoBannerRebrand';
import ProofPointStackedCollection from '@/components/ProofPointStackedCollectionRebrand/ProofPointStackedCollectionRebrand';
import { PageContext } from '../context/PageContext';
import Hero from '@/components/HeroRebrand/HeroRebrand';
import ProofPointCollection from '@/components/ProofPointCollectionRebrand/ProofPointCollectionRebrand';
import CardCollection from '../components/CardCollectionRebrand/CardCollectionRebrand';

// Import our isolated modal component

const IndexPage = () => {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  console.log('state', state);

  const proofPointsStackedData = {
    title: 'Why partner with Gem?',
    proofPoints: [
      {
        title: 'It’s easy',
        description:
          'Apply in minutes, manage online, and turn plans into action.',
        icon: 'icon-check-rebrand'
      },
      {
        title: 'We’re with you',
        description:
          'Whether you’re growing your family or building credit, we’re in it with you.',
        icon: 'icon-handshake-rebrand'
      },
      {
        title: 'Tailored to you',
        description:
          'Life isn’t a formula, so we customise our rates to fit your unique situation.',
        icon: 'icon-register-rebrand'
      },
      {
        title: 'No surprises',
        description:
          'Clear fees, real rates. We keep it simple so you can focus on what’s next.',
        icon: 'icon-smile-rebrand'
      }
    ]
  };
  const cardCollectionData = {
    title: 'What’s important to you?',
    background: REBRAND_COLOR.STONE,
    cards: [
      {
        id: '$200 credit back',
        image: '/media/home/home-200-credit-back-tile.webp',
        title: '$200 credit back',
        description:
          'Shop smart and earn $200 credit back when you spend $2,000 per month on purchases, including Interest Free plans, for the first 4 months after approval with your Gem Visa credit card<sup>^</sup>.',
        button: {
          variant: 'primary',
          size: 'lg',
          text: 'Find out more',
          url: '/credit-cards/gem-visa-card/'
        }
      },
      {
        id: 'need-new-wheels',
        image: '/media/home/home-carousel-1.png',
        title: 'Need new wheels?',
        description:
          'Ready for some new wheels or just an upgrade? Check out our car loans.',
        button: {
          variant: 'primary',
          size: 'lg',
          text: 'Learn more',
          url: '/loans/car-loans/'
        }
      },
      {
        id: 'shop-interest-free',
        image: '/media/home/home-carousel-4.jpg',
        title: 'Shop Interest Free*',
        description:
          'Choose a Gem Visa credit card for freedom, flexibility and access to our Gem Visa deals.',
        button: {
          variant: 'primary',
          size: 'lg',
          text: 'Learn more',
          url: '/credit-cards/where-to-shop/'
        }
      },
      {
        id: 'consolidating-your-debts',
        image: '/media/home/home-carousel-2.png',
        title: 'Consolidating your debts',
        description: 'Destress your mind with a debt consolidation loan.',
        button: {
          variant: 'primary',
          size: 'lg',
          text: 'Learn more',
          url: '/loans/debt-consolidation-loans/'
        }
      },
      {
        id: 'make-it-happen',
        image: '/media/home/home-carousel-3.png',
        title: 'Make it happen',
        description:
          'Wedding, travel or home renos, we’ve got you covered with our personal loans.',
        button: {
          variant: 'primary',
          size: 'lg',
          text: 'Learn more',
          url: '/loans/personal-loans/'
        }
      }
    ]
  };

  const proofPointsData = {
    title: 'Calculator and tools',
    proofPoints: [
      {
        title: 'Personal loan repayment calculator',
        proofPointUrl: '/loans/loan-repayment-calculator/',
        icon: 'icon-calculator-rebrand'
      },
      {
        title: 'Car loan repayment calculator',
        proofPointUrl: '/loans/car-loan-repayment-calculator/',
        icon: 'icon-car-profile-rebrand'
      },
      {
        title: 'Budget planner',
        proofPointUrl: '/loans/budget-planner/',
        icon: 'icon-table-rebrand'
      }
    ]
  };

  return (
    <Layout noMetaKeywords>
      <MobileAppInstallPrompts />
      <main className="navigation-spacer gem-home-page">
        <Helmet>
          <link rel="canonical" href="https://www.gemfinance.co.nz/" />
          <title>Gem by Latitude | New Zealand Loans &amp; Credit Cards</title>
          <meta
            name="description"
            content="Gem by Latitude is your Partner in Money, from personal loans to credit cards. Let's help you find a way. T&amp;Cs &amp; fees apply."
          />
        </Helmet>

        <Hero
          heading={
            <>
              Expand your <br />
              <u>possibilities</u>
            </>
          }
          subHeading={
            'Financing solutions as individual as you are. What are you looking for today?'
          }
          backgroundImageUrl={'/media/home/home-hero.webp'}
          primaryCta={{
            text: 'Credit cards',
            url: '/credit-cards/gem-visa-card/'
          }}
          secondaryCta={{
            text: 'Personal loans',
            url: '/loans/personal-loans/'
          }}
        />

        <ProofPointStackedCollection data={proofPointsStackedData} />

        {/*        <div
   css={`
     max-width: 374px;
     margin: 0 auto;
   `}
 >
   {state?.promoBannerData?.[2] && (
     <PromoBannerCarousel {...state?.promoBannerData[2]} />
   )}
 </div>*/}

        <PromoBanner
          heading={'Pay no loan establishment fee'}
          isReversed={true}
          fullWidth={false}
          description={
            <>When you apply for a Gem Personal Loan by 11 December 2026.</>
          }
          image={'/media/promo-nz-lef.webp'}
          button={{
            variant: 'secondary-blue',
            size: 'lg',
            text: 'Find out more',
            url: '/loans/personal-loans/'
          }}
          tcText={
            <>
              Establishment fee waived until 11 December 2026. Lending criteria,
              T&Cs and fees apply.
            </>
          }
        />

        <PromoBanner
          heading={'$200 credit back'}
          isReversed={true}
          fullWidth={false}
          description={
            <>
              Shop smart and earn $200 credit back when you spend $2,000 per
              month on purchases, including Interest Free plans, for the first 4
              months after approval with your Gem Visa credit card.
            </>
          }
          image={'/media/promo-nz-200-credit-back.webp'}
          button={{
            variant: 'secondary-blue',
            size: 'lg',
            text: 'Find out more',
            url: '/credit-cards/gem-visa-card/'
          }}
          tcText={
            <>
              New customers only, must be approved by 29 January 2027. Lending
              criteria, T&Cs and fees apply including $65 Annual fee (charged
              half-yearly) and $55 Establishment fee.
            </>
          }
        />

        <PromoBanner
          heading={'Reset with a Gem Personal Loan'}
          isReversed={true}
          fullWidth={false}
          description={
            <>
              Go confidently with a simple application, plus the option of no
              repayments for the first 3 months subject to eligibility criteria
              <sup>*</sup>.
            </>
          }
          image={'/media/promo-nz-reset-finances.png'}
          button={{
            variant: 'secondary-blue',
            size: 'lg',
            text: 'Learn more',
            url: '/loans/personal-loans/'
          }}
          tcText={
            <>
              <sup>*</sup>Lending criteria, T&Cs, fees and other charges apply.
            </>
          }
        />

        <ProofPointCollection data={proofPointsData} />

        <CardCollection {...cardCollectionData} />

        <ImportantInformation
          css={`
            overflow-x: hidden;
            .row {
              @media (min-width: 1600px) {
                padding-left: ${PADDING.P32};
                padding-right: ${PADDING.P32};
              }
            }
          `}
          data={require('../data/json/disclaimer/default.json')}
          {...{
            ...state?.importantInfoData?.[0],
            sectionOneColummClasses: 'col-12 col-lg-6',
            sectionTwoColummClasses: 'col-12 col-lg-6'
          }}
        />
      </main>
    </Layout>
  );
};

export default IndexPage;
